import { type ISbError } from "@storyblok/react"
import { fetchSbStory } from "../lib/api"

export enum StoryblokComponentStories {
    MarketingReinsurance = "marketing-reinsurance",
}

export async function getPropsWithGlobalComponentStory(
    preview: boolean,
    slug: string,
    additionalProps?: Record<string, unknown>
) {
    try {
        const story = await fetchSbStory<"globalComponent">(`components/${slug}`)

        return {
            props: {
                story,
                preview,
                ...additionalProps,
            },
        }
    } catch (err) {
        if ((err as ISbError).status !== 404) {
            console.error(`An error occured retrieving ${slug} story`, err)
            throw err
        }

        // eslint-disable-next-line no-console
        console.log(`Could not find story with slug ${slug}`, err)

        return {
            notFound: true,
        }
    }
}
